module.exports = __webpack_public_path__ + "static/media/1.38052338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.png
// module id = 1485
// module chunks = 1